import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";


export default css`
  :global(.styled-slider) {
    width: calc(100% - 24px);
  }
  :global(.sliderFilterContainer) {
    width: 93%;
    margin: 10px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  :global(.rc-slider) {
    overflow: visible !important;
    padding: 10px 0px;
  }

  :global(.Modal_content:first-child .rc-slider) {
    overflow: visible !important;
  }

  :global(.SliderFilterInputContainer) {
    margin-top: 20px;
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }

  :global(.SliderFilterInput) {
    width: 45%;
    padding: 0.4rem;
    color: ${getColor(COLOR_DICTIONARY.BLACK)};

    text-align: center;
    border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_500)};
    border-radius: 0.25rem;
    text-size-adjust: none;
  }

  :global(.SliderFilterInput:focus) {
    box-shadow: rgb(0, 105, 167) 0px 0px 5px 0px;
  }

  :global(.rc-slider-track) {
    background-color: ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
  }

  :global(.rc-slider-handle:hover) {
    border-color: ${getColor(COLOR_DICTIONARY.BLUE_800)};
  }

  :global(.rc-slider-handle) {
    position: absolute;
    z-index: 1;
    width: 24px;
    height: 24px;
    margin-top: -10px;
    background-color: ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
    border: 2px solid ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
    border-radius: 50%;
    cursor: pointer;
    cursor: grab;
    opacity: 1;
    touch-action: pan-x;
  }

  :global(.SliderFilterInputSeparator) {
    width: 0.5rem;
    height: 1px;
    background-color: rgb(204, 204, 204);
  }

  @media (max-width: 969px) {
    :global(.sliderFilterContainer) {
      padding: 3px 15px;
    }
  }
`;
